import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { Button, ButtonIcon } from 'primeng/button';
import { Tooltip } from 'primeng/tooltip';

/**
 * Icon-only PrimeNG button wrapper with a Material icon and context-specific
 * color variants. Uses CSS-variable overrides on `:host` instead of global
 * SCSS — see `@u2b-ui/README.md`.
 */
export type U2bIconButtonVariant =
    | 'default'      // Standard PrimeNG primary-text button
    | 'on-primary';  // White icon on a colored (primary) background

@Component({
    selector: 'u2b-icon-button',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [Button, ButtonIcon, Tooltip],
    host: {
        class: 'inline-flex',
        '[attr.variant]': 'variant()',
    },
    template: `
        <p-button
            [text]="true"
            [disabled]="disabled()"
            [pTooltip]="tooltip() || null"
            [tooltipPosition]="tooltipPosition()"
            [attr.aria-label]="ariaLabel()"
            (onClick)="clicked.emit($event)">
            <span pButtonIcon class="material-icons">{{ icon() }}</span>
        </p-button>
    `,
    styleUrls: ['./u2b-icon-button.component.scss'],
})
export class U2bIconButtonComponent {

    readonly icon = input.required<string>();

    readonly ariaLabel = input.required<string>();

    readonly variant = input<U2bIconButtonVariant>('default');

    readonly disabled = input<boolean>(false);

    readonly tooltip = input<string | null>(null);

    readonly tooltipPosition = input<'top' | 'bottom' | 'left' | 'right'>('bottom');

    readonly clicked = output<MouseEvent>();
}
